import { render } from "./ActivateAccount.vue?vue&type=template&id=e12fa8b8&scoped=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"

import "./ActivateAccount.vue?vue&type=style&index=0&id=e12fa8b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12fa8b8"]])

export default __exports__